define(['edge/platform/base/BaseCtrl','underscore'], (BaseCtrl)=> {
    const fn = ($scope, $state, $rootScope, $q, $filter, $anchorScroll, ModalService, submissionViewModel,AgeAllowedForHO, AvailabilityService,StateUtils,LocaleService, InputValidationService)=> {

        const ctrl = Object.create(BaseCtrl);        
        const flowModel = StateUtils.activeDataForState(true).flowModel;
        const submissionVM = submissionViewModel();
       
ctrl.init = ()=> {
    $anchorScroll();
    $scope.isPeriodStartDateValid = true;
    $scope.phoneMask = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9');
    //DFCT0020397 - QnB Date Of Birth Validation -Arpita
    $scope.minDob = "01-01-1800";
    $scope.isMinDateOfBirthValid = true;
    $scope.isNameValid = true//ENHC0013007 -- Insurance Premium Refunds --Arpita
   //DFCT0020397 - QnB Date Of Birth Validation ends
            
            //This function is used to remove prefill data needed to obtain a quote for streamlined submissions.
            const sanitisePrefillDataFromQuickQuote = (accountHolder) => {
                                if (accountHolder.firstName === '0streamlinedquote0') {
                                accountHolder.firstName = undefined;
                                        accountHolder.lastName = undefined;
                                        accountHolder.dateOfBirth = undefined;
            }
            };
            const submissionVM = submissionViewModel();
            
            $scope.submissionVM = submissionVM;

            //Added for Cancel button on Personal Information
            //screen of Personal Auto - 10011- GW-QB-Quote-My information_AUTO
            $scope.goToCancel = (form) => {
                if ($scope.cancel) {
                    $scope.cancel((_model, args) => flowModel.cancel(_model, args), form);
                } else {
                    flowModel.cancel(model);
                }
            };
            const today = new Date();

            $scope.accountHolder = $scope.submissionVM.draftData.accountHolder.value;
            
            //Added for the defect DE1321
            $scope.accountCellNumber = $scope.accountHolder.cellNumber;
            $scope.accountWorkNumber = $scope.accountHolder.workNumber;
            $scope.accountHomeNumber = $scope.accountHolder.homeNumber;
            //ENHC0012832 - North Carolina Property Rate Review effective 02/01/2024
            // Not display occupation typecodes from this list
            $scope.occupationFilterCodes = ["studentawaymorethan100mi"];

           //Added for defect DE823
            if($scope.accountHolder.primaryPhoneType == "mobile"){
                $scope.submissionVM.draftData.accountHolder.homeNumber = $scope.accountHolder.cellNumber;
            }else if($scope.accountHolder.primaryPhoneType == "home") {
                $scope.submissionVM.draftData.accountHolder.homeNumber = $scope.accountHolder.homeNumber;
            }else if($scope.accountHolder.primaryPhoneType == "work") {
                $scope.submissionVM.draftData.accountHolder.homeNumber = $scope.accountHolder.workNumber;
            }
            // DFCT0021660-phone no display issue
            if($scope.submissionVM.draftData.accountHolder.value.cellNumber && $scope.submissionVM.draftData.accountHolder.value.cellNumber.length>10){
                $scope.submissionVM.draftData.accountHolder.value.cellNumber = $scope.submissionVM.draftData.accountHolder.value.cellNumber.slice($scope.submissionVM.draftData.accountHolder.value.cellNumber.length-10)
            }//ended
            /*$scope.accountHolder.primaryPhoneType = null;*/
            $scope.submissionVM.draftData.accountHolder.value.ageLimit = 18;
            submissionVM.draftData.policyAddress.addressType.value = submissionVM.draftData.policyAddress.addressType.value || 'home';
            
            // adding function to update period start date --Arpita Sengupta
            $scope.submissionVM.draftData.periodStartDate.value = $scope.submissionVM.draftData.periodStartDate.value ? $scope.submissionVM.draftData.periodStartDate.value : today;
            let startDt = new Date($scope.submissionVM.draftData.periodStartDate.value);
            const effectiveDtManipulation = (addedDt) => {
                let defaultEffDt = Date.UTC(addedDt.getUTCFullYear(), addedDt.getUTCMonth(),
                    addedDt.getUTCDate(), addedDt.getUTCHours(),
                    addedDt.getUTCMinutes(), addedDt.getUTCSeconds()
                );
                console.log('new changes',new Date(defaultEffDt));
                $scope.submissionVM.draftData.periodStartDate.value = new Date(defaultEffDt);
            };
            if(!$scope.submissionVM.quoteID.value){
                startDt.setDate(startDt.getDate() + 10);
                effectiveDtManipulation(startDt);
            }
            //for quote retrieval
            if ($scope.submissionVM.quoteID.value && new Date(startDt).setHours(0,0,0,0) < new Date().setHours(0,0,0,0)) {
                let formtdt = new Date(today.toISOString());                
                formtdt.setDate(formtdt.getDate() + 10);
                effectiveDtManipulation(formtdt);
            }   
            //ended

            $scope.entryDate = $scope.submissionVM.draftData.periodStartDate.value;
            $scope.today = new Date();
            $scope.today.setHours(0, 0, 0, 0);
            
            
            $scope.coverageStartDt = today.setHours(720)
            /*current date from the Calendar fix by devendra start*/
            if(new Date().getTimezoneOffset() > 0){
                $scope.today.setHours(-1);
            }
            /*current date from the Calendar fix by devendra end*/
            var currentDate = new Date();
            
            $scope.maxDateOfBirth = {
                year: currentDate.getFullYear() - AgeAllowedForHO,
                month: currentDate.getMonth(),
                day: currentDate.getDate()
            };

        // CHG0031104 - Set QnB Source, Credit Union Member Flag and Credit Union Join year
        // AB - 05/14/2018

         // CHG0057320 - Add SEA & YOMTOB Inc. for QnB Links
         // AB - 11/23/2020

            if ($rootScope.Arg1 == null){
                var arg1 = $rootScope.Arg1
            }else{
                var arg1 = $rootScope.Arg1.toUpperCase()
            }

            switch(arg1){
                case "GORMISH":
                case "SEA":
                case "YOMTOB":
                case "SECU":
                case "BWE":
                case "SCOTT":
                case "MERRILL":
                case "CROWFIELD":
                case "RICKARD":
                case "NIXON":
                case "BLUE":
                case "GRAY":
                case "JONES":
                case "MCCARTHY":
                case "ASSOCIATES":
                case "ANTHONY":
                case "SIMMONS":
                case "WILLIAMS":
                case "MORRISON":
                case "CRUMEL":
                case "YOU":
                case "MILLER":
                case "PERSINSKI":
                case "FLOURNOY":
                  $scope.submissionVM.draftData.accountHolder.qnbSource = $rootScope.Arg1.toUpperCase();
//                  $scope.submissionVM.draftData.accountHolder.qnbSource = "SECU";
//                  $scope.submissionVM.draftData.accountHolder.isCreditUnionMember = true
//                  $scope.submissionVM.draftData.accountHolder.joinedYearCreditUnionMembership = (new Date()).getFullYear()
                  break
                default:
                  $scope.submissionVM.draftData.accountHolder.qnbSource = null;
//                  $scope.submissionVM.draftData.accountHolder.qnbSource = $rootScope.Arg1.toUpperCase();
            }

            // Check for the valid account holder details
            var isValidAccount = $scope.accountHolder["emailAddress1"] ? true : false;
            if (!isValidAccount) {

                var accountDetails = angular.copy($rootScope.accountDetails);
                var accountHolder = accountDetails.accountHolder;
                var accountHolderAddress = accountDetails.accountHolderAddress;
                // check account exists
                if (accountHolder.accountExists) {

                    // Fill Account Details
                    $scope.accountHolder.publicID = accountHolder.publicID;
                    $scope.accountHolder.accountNumber = accountHolder.accountNumber;
                    $scope.accountHolder.displayName = accountHolder.displayName;
                    $scope.accountHolder.accountExists = accountHolder.accountExists;
                    $scope.accountHolder.firstName = accountHolder.firstName;
                    $scope.accountHolder.lastName = accountHolder.lastName;
                    $scope.accountHolder.emailAddress1 = accountHolder.emailAddress1;
                    $scope.accountHolder.emailExist = true;
                    var dateOfBirth = accountHolder.dateOfBirth;
                    var day = parseInt($filter('date')(dateOfBirth, "dd"));
                    var month = parseInt($filter('date')(dateOfBirth, "MM")) - 1;
                    var year = parseInt($filter('date')(dateOfBirth, "yyyy"));
                    //console.log("DateOfBirth: ", day, month, year);
                    $scope.accountHolder.dateOfBirth = {
                        day : day,
                        month : month,
                        year : year
                    };
                    //console.log("DateOfBirth: ", $scope.accountHolder.dateOfBirth);
                    $scope.accountHolder.workNumber = accountHolder.workNumber;
                    $scope.accountHolder.homeNumber = accountHolder.homeNumber;
                    $scope.accountHolder.cellNumber = accountHolder.cellNumber;
                    $scope.accountHolder.middleName = accountHolder.middleName;
                    $scope.accountHolder.suffix = accountHolder.suffix;

                    // Fill Policy Address
                    $scope.submissionVM.draftData.policyAddress.addressLine1 = accountHolderAddress.addressLine1;
                    $scope.submissionVM.draftData.policyAddress.addressLine2 = accountHolderAddress.addressLine2;
                    $scope.submissionVM.draftData.policyAddress.addressLine3 = accountHolderAddress.addressLine3;
                    $scope.submissionVM.draftData.policyAddress.state = accountHolderAddress.state;
                    $scope.submissionVM.draftData.policyAddress.city = accountHolderAddress.city;
                } else {
                    $scope.accountHolder.accountExists = accountHolder.accountExists;
                }

                // Remove accountDetails object from rootscope
                $rootScope.accountDetails = {
                    accountHolder : {
                        accountExists: false
                    }
                };
            }
            
             //console.log("Printing inside Contact details",$scope.questionSets)
        };

        //DFCT0020397 - QnB Date Of Birth Validation -Arpita
        ctrl.checkDate = function (){
            if($scope.submissionVM.draftData.accountHolder.dateOfBirth.value.year && ($scope.submissionVM.draftData.accountHolder.dateOfBirth.value.year < "1800")){
                $scope.isMinDateOfBirthValid = false
                $scope.submissionVM.draftData.accountHolder.dateOfBirth.value = ''
            }else{
                $scope.isMinDateOfBirthValid = true
            }
        }
        //DFCT0020397 - QnB Date Of Birth Validation ends
        
        /*ctrl.showDisclosure = () => {
        var toShow = "<div class='yourInfo-static'><div class='yourInfo-static-message'><h4>Information disclosure</h4><p>{{'quoteandbind.ho.views.contact-details.informationdisclosure.static'|translate}}</p></div></div>";
                ModalService.showSimpleDialog(toShow)
        };*/
        function validateInputs (inputsToValidate, scopeVar) {
            let inputValidationData = [];
            inputValidationData = InputValidationService.isInputValid(inputsToValidate)
            if(!inputValidationData[0] && inputValidationData[1].length > 0){
                for (let i=0; i<inputValidationData[1].length; i++){
                    scopeVar[inputValidationData[1][i]] = ''
                    $scope.isNameValid = false;
                }
            }else{
                $scope.isNameValid = true;
            }
        }
        ctrl.displayDisclaimer = (form) => {

            // Changes for incident INC0019053 begins

            var currentDateForBackDate = new Date();
            var diffOfDaysForBackDate = moment(currentDateForBackDate).startOf('day').diff(moment($scope.submissionVM.draftData.periodStartDate.value).startOf('day'), 'days');
            const submissionVM = submissionViewModel();
            //ENHC0013007 -- Insurance Premium Refunds --Arpita
            let inputsToValidate = [
                {'firstName' : $scope.submissionVM.draftData.accountHolder.firstName.value},
                {'middleName' : $scope.submissionVM.draftData.accountHolder.middleName.value},
                {'lastName' : $scope.submissionVM.draftData.accountHolder.lastName.value}                
            ];
            let primaryAddInput = [
                {'addressLine1' : $scope.submissionVM.draftData.policyAddress.addressLine1.value},
                {'addressLine2' : $scope.submissionVM.draftData.policyAddress.addressLine2.value},
                {'city' : $scope.submissionVM.draftData.policyAddress.city.value}
            ]
            validateInputs(inputsToValidate,$scope.submissionVM.draftData.accountHolder.value)
            if(!$scope.isNameValid){
                return;
            }
            validateInputs(primaryAddInput,$scope.submissionVM.draftData.policyAddress.value)
            if(!$scope.isNameValid){
                return;
            }
            //ended
            // Period Start Date should not be back date
            if(diffOfDaysForBackDate >= 1){
                $scope.isPeriodStartDateValid = false;
                //$state.go('contactUs', {quoteID: (submissionVM) ? submissionVM.quoteID.value : null,errorMsg :submissionVM.draftData.lobs.value.exception });
                return;
            }

            var diffOfDaysForFutureDate = moment($scope.submissionVM.draftData.periodStartDate.value).startOf('day').diff(moment(currentDateForBackDate).startOf('day'), 'days');
            if(diffOfDaysForFutureDate > 30){
                submissionVM.draftData.lobs.value = {};
                $scope.isPeriodStartDateValid = false;
                //$state.go('contactUs', {quoteID: (submissionVM) ? submissionVM.quoteID.value : null,errorMsg :submissionVM.draftData.lobs.value.exception });
                return;
            }

            var policyEnqDate = new Date($scope.entryDate);
            var diffOfDays = moment($scope.submissionVM.draftData.periodStartDate.value).startOf('day').diff(moment(policyEnqDate).startOf('day'), 'days');
            
            // Period Start Date should not be more than 30 days from date of quotation
            if(diffOfDays > 30){
                $scope.isPeriodStartDateValid = false;
                // $state.go('contactUs', {quoteID: (submissionVM) ? submissionVM.quoteID.value : null,errorMsg :submissionVM.draftData.lobs.value.exception });
                return;
            }
            // Changes for incident INC0019053 ends
            //DFCT0020397 - QnB Date Of Birth Validation -Arpita
            if($scope.submissionVM.draftData.accountHolder.dateOfBirth.value.year && ($scope.submissionVM.draftData.accountHolder.dateOfBirth.value.year < "1800")){
                $scope.isMinDateOfBirthValid = false
                $scope.submissionVM.draftData.accountHolder.dateOfBirth.value = ''
                return;
            }
            //DFCT0020397 - QnB Date Of Birth Validation ends

            
        var title = "Information Disclosure"
                var message = "I understand that as part of the underwriting process, in most states you will order an insurance score based upon credit history which may be used to rate my policy. Consumer reports that contain information about driving and claims history are also obtained. I further understand that I have the right to be told the name and address of the reporting agencies providing these reports and to see and correct my personal information." +
                    "If you receive corrected information from a consumer reporting agency, you will re-evaluate the information. I understand that you may disclose this information to conduct your business and that I have a right to obtain a copy of the the company's privacy policy. By clicking next I've confirmed that I've read the information disclosure and would like to proceed with my quote."
                var continueModel = ModalService.showDisclaimer(title, message)
                continueModel.result.then(function(){ctrl.setNextState(form)}, function(){})
        };
        ctrl.next = function (form) {
            //console.log("Printing inside Contact details1111", $scope.questionSets)
            $scope.submissionVM.draftData.accountHolder.value.emailExist = true;
        form.submitted = true;
            if($scope.submissionVM.draftData.accountHolder.value.emailAddress1 == undefined || $scope.submissionVM.draftData.accountHolder.value.emailAddress1 == ''){
                return false;
            }
                flowModel.next(submissionVM);
                
                };
       
        ctrl.cancel = function () {
        flowModel.cancel(submissionVM);
                };
        ctrl.setNextState= (form) => {
            if(!$scope.accountHolder.accountExists){
                //ENHC0011876- changed from home to mobile
                $scope.submissionVM.draftData.accountHolder.value.primaryPhoneType = "mobile";
            }else{
                //Added for the defect DE1321
                $scope.submissionVM.draftData.accountHolder.value.primaryPhoneType = $scope.accountHolder.primaryPhoneType;
                $scope.submissionVM.draftData.accountHolder.cellNumber = $scope.accountCellNumber;
                $scope.submissionVM.draftData.accountHolder.homeNumber = $scope.accountHomeNumber;
                $scope.submissionVM.draftData.accountHolder.workNumber = $scope.accountWorkNumber;
            }
            //console.log("inside HO next State: ",$scope.submissionVM.draftData)
           //console.log("Printing inside Contact details222", $scope.questionSets)
            //This is hardcoded to Oregon
                //$scope.submissionVM.draftData.policyAddress.county = "OR";
                 //console.log("Scope Address", $scope.address)
                //console.log("Print Form ", form)
               // console.log("Print Form valid", form.valid)
                form.submitted =true;

            


                if (!form.valid) {
                    //console.log("Invalid form inside HO next State")    
                    return;
                }
                else {
                    // $scope.saveQuote();
                    ctrl.next(form)
                    }
        };
        
        
        return ctrl.create($scope);
    };
    fn.$inject = ['$scope', '$state', '$rootScope', '$q', '$filter', '$anchorScroll','ModalService', 'submissionViewModel', 'AgeAllowedForHO', 'AvailabilityService','StateUtils','LocaleService','qnb.InputValidationService'];

    return fn;
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/ho/controllers/HOContactDetailsCtrl.js
 **/